import { Flex, forwardRef, Text } from '@chakra-ui/react'
import { useDeviceType } from 'app/hooks'
import { useEffect } from 'react'

interface IToggleSwitch {
  enabled: boolean
  setEnabled: React.Dispatch<React.SetStateAction<boolean>>
  enabledLabel?: string
  disabledLabel?: string
  changeHandler?: (enabled: boolean) => void
}

const ToggleSwitch = forwardRef((props: IToggleSwitch, ref) => {
  const {
    enabled,
    setEnabled,
    enabledLabel = 'Yes',
    disabledLabel = 'No',
    changeHandler,
    ...rest
  } = props
  const { isDesktop } = useDeviceType()

  useEffect(() => {
    if (changeHandler) {
      changeHandler(enabled)
    }
  }, [enabled])

  return (
    <Flex
      role='switch'
      alignItems='center'
      userSelect='none'
      w={isDesktop ? 'full' : ''}
      ref={ref}
      {...rest}
    >
      <Text
        bgColor={enabled ? 'secondary2.50' : 'white'}
        color={enabled ? 'secondary2.700' : 'gray'}
        paddingY='1.5'
        paddingX={isDesktop ? '12' : '6'}
        border='1px'
        borderLeftRadius='md'
        cursor='pointer'
        onClick={() => {
          setEnabled(true)
        }}
        borderColor={'secondary2.600'}
        borderRightWidth={'0px'}
      >
        {enabledLabel}
      </Text>
      <Text
        bgColor={!enabled ? 'secondary2.50' : 'white'}
        color={!enabled ? 'secondary2.700' : 'gray'}
        paddingY='1.5'
        paddingX={isDesktop ? '12' : '6'}
        cursor='pointer'
        onClick={() => {
          setEnabled(false)
        }}
        border='1px'
        borderRightRadius='md'
        borderColor={'secondary2.600'}
      >
        {disabledLabel}
      </Text>
    </Flex>
  )
})

export { ToggleSwitch }
